import { useEffect, useState } from "react";

export interface FileExt extends File {
  progress?: number;
  uri?: string;
  keyId?: string;
  xades?: Blob;
  writingType?: string;
}

function useFiles() {
  const [files, setFiles] = useState<FileExt[]>([]);
  const [size, setSize] = useState<number>(0);

  const calcSize = () => {
    const s = files.reduce((sum, current) => sum + current.size, 0);
    setSize(s);
  };

  const addNewFile = (file: File) => {
    setFiles((prev) => [...prev, file]);
  };
  const removeFile = (index: number) => {
    setFiles(files.filter((file, fileIndex) => index !== fileIndex));
  };

  useEffect(() => {
    calcSize();
  }, [files]);

  return {
    files,
    setFiles,
    addNewFile,
    removeFile,
    size,
  };
}

export default useFiles;
